<template>
  <div class="lwri">
    <div class="lwri__wording">
      <paragraph :wording="wording" />
    </div>
    <div class="lwri__image">
      <img class="lwri__image__img" :src="src"/>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import Paragraph from '@/components/Global/Paragraph.vue';

export default defineComponent({
  name: 'LeftWordingRightImage',
  components: {
    Paragraph,
  },
  props: {
    wording: {
      type: Array,
      default: () => [],
    },
    src: {
      default: null,
    },
  },
});

</script>
<style lang="scss" scoped>
@import '~@/styles/utils/_rwd.scss';
.lwri {
  @include flex(flex-start, flex-start, column);

  &__image {
    width: 100%;
    text-align: center;

    &__img {
      width: 200px;
    }
  }
}

@media screen and (min-width: $tablet) {
  .lwri {
    @include flex();
    &__wording {
      flex: 1;
    }

    &__image {
      flex: none;
      width: 200px;
      margin-left: 30px;

    }

  }
}
</style>
